import { Fragment } from 'react';
import { useStore } from 'zustand';

import { overlayStore } from './overlay.store';

/**
 * 명령형 오버레이를 그리는 자리. app 레이어가 라우터 안에 한 번만 마운트한다.
 * 덮개(backdrop) · 포커스 가두기 · z-index 는 넘겨받은 컴포넌트(Dialog · Drawer atom)가 맡는다.
 */
export function OverlayHost() {
  const entries = useStore(overlayStore, (state) => state.entries);

  return (
    <>
      {entries.map((entry) => (
        <Fragment key={entry.id}>{entry.render()}</Fragment>
      ))}
    </>
  );
}
